import { fetch } from '@/api/service.js'
const prefix = '/xyactivity/java-campus-c-operation'
const bffPrefix = '/bff'

// 根据id查询推荐信息
export const getRecommendInfoById = (data) =>
  fetch('post', 'json', prefix + '/campusrd/getRecommendInfoById', data)

// 根据id查询推荐信息
export const getRecommendInfo = (data) =>
  fetch('post', 'json', bffPrefix + '/campusrd/getRecommendInfo', data)

// 根据公司编号查询企业详情
export const getCompanyInfo = (data) =>
  fetch('post', 'json', bffPrefix + `/campusrd/getCompanyInfo`, data)

export const getCompanyInfoByType = (data) =>
  fetch('post', 'json', bffPrefix + `/campusrd/getCompanyInfoByType`, data)

// 根据职位编号查询职位详情
export const getJobInfo = (data) => fetch('post', 'json', bffPrefix + `/campusrd/getJobInfo`, data)

export const getJobInfoByType = (data) =>
  fetch('post', 'json', bffPrefix + `/campusrd/getJobInfoByType`, data)

// 根据公司查询职位
// export const getJobByCompany = (data) =>
//   fetch("post", "json", prefix + `/campusrd/getJobByCompany`, data);
export const getJobByCompany = (data) =>
  fetch('post', 'json', bffPrefix + `/campusrd/getJobByCompany`, data)

// 根据公司查询第一个推荐职位
export const getRecommendJobByCompany = (data) =>
  fetch('post', 'json', bffPrefix + `/campusrd/getRecommendJobByCompany`, data)
getRecommendJobByCompany

// 根据总公司编号获取分公司列表
export const getCompanyByRoot = (data) =>
  fetch('post', 'json', prefix + `/campusrd/getCompanyByRoot`, data)

// 根据id获取双选会详情
export const getJobFairDetail = (data) =>
  fetch('post', 'json', prefix + `/campusrd/getJobFairDetail`, data)

// 添加效果监控数据
export const addRecommendEffectMonitoring = (data) =>
  fetch('post', 'json', prefix + `/campusrd/addRecommendEffectMonitoring`, data)
